export default "__VITE_ASSET__CShpSsAj__"